import React, { useRef } from "react";
import { Box, Card, CardBody, CardFooter, CardHeader, Image, Text } from "grommet";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import ParallaxTilt2 from "../components/ParallaxTilt2";
import { CoachViewModel } from "./CoachStore";
import Avatar from "react-avatar";
import { useDarkMode } from "../components/DarkModeSwitch";

export const CoachCard: React.FC<{ coach: CoachViewModel }> = ({ coach }) => {
    const [isDarkMode] = useDarkMode();

    return (
        <Link to={`/coaches/${coach.id}`} style={{ textDecoration: "none" }}>
            <ParallaxTilt2>
                <Card width="250px" height="medium" background="background">
                    <CardHeader pad="small" justify="center" fill="horizontal">
                        <Text>{coach.name}</Text>
                    </CardHeader>
                    <CardBody pad="small" align="between" justify="between">
                        <Box align="center">
                            <Avatar src={coach.logoUri} size="180px" round />
                        </Box>
                        <Box direction="row" gap="small" justify="center" align="center" fill="horizontal">
                            {coach.games.map((game) => (
                                <Image src={isDarkMode ? `/images/logos/${game}.png` : `/images/logos/${game}-light.png`} style={{ maxWidth: "100px", maxHeight: "50px" }}></Image>
                            ))}
                            {/* <Box direction="row" gap="small" align="center">
                                <FontAwesomeIcon icon={["fad", "swords"]}></FontAwesomeIcon>
                                <Text>{coach.matchesPlayed}</Text>
                            </Box>
                            <Box direction="row" gap="small" align="center">
                                <Text>{coach.matchesWon}</Text>
                                <FontAwesomeIcon icon={["fad", "trophy"]}></FontAwesomeIcon>
                            </Box> */}
                        </Box>
                    </CardBody>
                    <CardFooter pad="small" background="background-front">
                        <Box pad="xsmall" background={"brand"} round="5px" justify="end">
                            <Text size="small">
                                {coach.price}
                                <small>/hr</small>
                            </Text>
                        </Box>
                    </CardFooter>
                </Card>
            </ParallaxTilt2>
        </Link>
    );
};
